import script from "./ThicknessSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThicknessSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ThicknessSelector.vue?vue&type=style&index=0&id=44aa26a7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44aa26a7"]])

export default __exports__